export default __webpack_public_path__ + "static/media/MVX_logo.c0980c68.svg";